var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Catalog",
    _vm._g(
      {
        attrs: {
          title: "Статус заказчика",
          "name-label": "Название статуса",
          "submit-error": "Укажите название статуса заказчика.",
          "fetch-data": _vm.fetchData,
          "put-data": _vm.putData,
          "post-data": _vm.postData,
          "exact-id": _vm.createId
        }
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfab15c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfab15c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/CustomerStatuses/CustomerStatus.vue
// module id = null
// module chunks = 